<div class="matrix_layoutMain container" v-bind:class="getClassNameContainer">
  <div class="row matrix_layoutPackingContainerMainRow">
    <div class="col-md-3 matrix_layoutPackingContainerSidebar">
      <appOptionsTable>
        <div class="matrix_optionsContainer">
          <appOptionsContainer hideContainer="true"></appOptionsContainer>
          <appPackingOptionsContainer
            hideContainer="true"
          ></appPackingOptionsContainer>
          <appPreviewButton></appPreviewButton>
          <appAddToCartButton v-show="getAddToCartFullPage"></appAddToCartButton>
        </div>
      </appOptionsTable>
      <appOtherOptionsTable>
        <appOtherOptionsContainer></appOtherOptionsContainer>
      </appOtherOptionsTable>
    </div>
    <div class="col-md-6 matrix_layoutPackingContainerMain">
      <appPackingPreview></appPackingPreview>
      <div class="matrix_layoutPackingActions">
        <appDownloadPDFButton></appDownloadPDFButton>
        <appUploadButton></appUploadButton>
        <appPersonalizationButton v-show="getPersonalizationFullPage"></appPersonalizationButton>
      </div>
      <appUploadContainer></appUploadContainer>      
    </div>
    <div class="col-md-3 matrix_layoutPackingContainerQuantity">
      <appQuantityTable>
        <appQuantityContainer></appQuantityContainer>
        <appInputQuantity></appInputQuantity>
      </appQuantityTable>
      <div class="matrix_summaryInformation">
        <appFactsheet></appFactsheet>
      </div>
    </div>
  </div>
</div>
